import React from 'react';
import { connect } from 'react-redux';
import SubHeader from './SubHeader';
import { setLoading } from '../../actions/authAction';
import {CopyToClipboard} from 'react-copy-to-clipboard';

class GenerateTagBr extends React.Component {
    state = {
        text: "",
        text2: "", copied: false,value:''
    };
    onValueChange = (v) => {
        let newstr = v.split('\n').join('<br>\n');
        this.setState({text2: newstr,text:v});
    }

    onClose = () =>{
        this.setState({isOpenMessage: false});
    }

    render() {
        return (
            <div className="flex-v home">
            <SubHeader text={`Encode Text`} />
                <br />
                <div style={{width:'90%',margin: 'auto'}}>
                <textarea className="textarea is-small" value={this.state.text} placeholder="Your message" onChange={e => this.onValueChange(e.target.value)} />
                        <br />
                        {this.state.text2 !=="" && 
                        <div>
                            <div>
                                <code style={{display: 'inline-block',width:'100%'}}>{this.state.text2}</code>
                            </div>
                            <div>
                                <CopyToClipboard text={this.state.text2} onCopy={() => alert('Copied')}>
                                    <button className="button is-info center" style={{display: "inline-block"}}>Copy</button>
                                </CopyToClipboard>
                            </div> 
                        </div>}
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        isAuthen: state.auth.isAuthen,
        auth: state.auth,
    }
}
export default connect(mapStateToProps, {
    setLoading
})(GenerateTagBr)